import { render, staticRenderFns } from "./detail_data_chart.vue?vue&type=template&id=4a8c7654&scoped=true"
import script from "./detail_data_chart.vue?vue&type=script&lang=js"
export * from "./detail_data_chart.vue?vue&type=script&lang=js"
import style0 from "./detail_data_chart.vue?vue&type=style&index=0&id=4a8c7654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c7654",
  null
  
)

export default component.exports